import { useEffect, useState } from "react";
import { Flame, Star } from "lucide-react";
import { api } from "@/lib/api";

const CONF_LABEL = { Max: "BEST BET", High: "STRONG", Medium: "LEAN", Fair: "LEAN", Board: "TOP FAVORITE" };

function PickRow({ p }) {
  const [open, setOpen] = useState(false);
  return (
    <button onClick={() => setOpen(!open)} className="w-full text-left py-2 border-b border-white/5 last:border-0" data-testid={`pick-${p.id}`}>
      <div className="flex items-center gap-3">
        <span className="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white shrink-0" style={{ backgroundColor: p.color }}>{p.pick_abbr}</span>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold text-smasher-gold">{p.league}</div>
          <div className="text-sm font-bold text-white truncate">{p.label}</div>
          <div className="text-[11px] text-slate-400 truncate">vs {p.opponent}</div>
          <div className="text-[10px] text-slate-500 font-mono-num">{p.date}{p.time ? ` · ${p.time} ET` : ""}</div>
        </div>
        <div className="text-right shrink-0">
          {p.odds && <div className="font-mono-num font-bold text-emerald-400 text-sm">{p.odds}</div>}
          <div className="text-[9px] text-smasher-gold flex items-center gap-0.5 justify-end"><Star className="w-2.5 h-2.5 fill-smasher-gold" /> {CONF_LABEL[p.confidence] || "PICK"}</div>
        </div>
      </div>
      {open && p.summary && <p className="text-[11px] text-slate-400 mt-2 leading-relaxed" data-testid={`pick-summary-${p.id}`}>{p.summary}</p>}
    </button>
  );
}

export default function TopPicks() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/top-picks").then((r) => setData(r.data)).catch(() => setData({ picks: [] }));
  }, []);
  const picks = data?.picks || [];
  return (
    <div className="panel p-4" data-testid="top-picks">
      <div className="flex items-center justify-between mb-3">
        <span className="flex items-center gap-2 font-heading font-bold tracking-wide text-smasher-gold"><Flame className="w-4 h-4" /> TODAY'S FREE PICKS</span>
        <span className="text-[9px] font-bold text-slate-500">NFL · NCAAF · NBA</span>
      </div>
      <div className="space-y-1">
        {picks.map((p) => <PickRow key={p.id} p={p} />)}
        {data && !picks.length && <p className="text-xs text-slate-500 py-3" data-testid="top-picks-empty">Today's picks post every morning — check back soon.</p>}
      </div>
      {picks.length > 0 && (
        <div className="text-[10px] text-slate-600 mt-2 leading-relaxed" data-testid="top-picks-cadence">
          Football picks refresh weekly · NBA picks refresh daily · tap a pick for the breakdown
        </div>
      )}
    </div>
  );
}
